// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"dbdade7d","488":"d292933d","747":"8abcfbb2","993":"dcef89e9"}[chunkId] + ".chunk.js";
};